export default __webpack_public_path__ + "static/media/kan-jam.30c8e509.svg";